import React from "react";
import "./styles.css";
import AddIcon from '@mui/icons-material/Add';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
    floatingButton: {
        position: 'fixed',
        marginRight: "1.75%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "1vw",
        padding: "0.5% 1.25%",
        height: "7.25vh",
        bottom: "5%",
        left: "82.5%",
        background: "var(--gradient, linear-gradient(270deg, #051572 0%, #0820B4 100%))",
        color: "#FFFFFF",
        borderRadius: "8px",
        cursor: "pointer",
        "&:hover": {
            border: "1px solid rgba(255, 255, 255, 0.12)",
            background: "var(--Gradient, linear-gradient(270deg, #051572 7.32%, #0820B4 92.68%))",
            boxShadow: "0px 0px 4px 1px rgba(8, 32, 180, 0.09), 0px 1px 6px 2px rgba(13, 30, 131, 0.31)",
        },
        "@media (max-width: 1200px)": {
            padding: "0.5% 1%",
            height: "6.5vh",
        },
        /* Phones: narrow pill on the right; label wraps to 2 lines (compact, less card overlap) */
        "@media (max-width: 900px)": {
            left: "auto",
            right: "max(10px, 2%)",
            marginRight: 0,
            width: "auto",
            maxWidth: "min(152px, 42vw)",
            minWidth: 0,
            padding: "8px 10px",
            height: "auto",
            minHeight: "44px",
            gap: "8px",
            alignItems: "center",
            fontSize: "0.8125rem",
            fontWeight: 600,
            lineHeight: 1.25,
        },
    },
    iconContainer: {
        borderRadius: "50%",
        background: "#2338AE",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        width: "2rem",
        height: "2rem",
        "@media (max-width: 900px)": {
            width: "1.75rem",
            height: "1.75rem",
        },
    },
    textContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minWidth: 0,
        "@media (max-width: 900px)": {
            alignItems: "flex-start",
            justifyContent: "center",
            maxWidth: "76px",
            textAlign: "left",
            lineHeight: 1.25,
        },
    },
    labelText: {
        "@media (max-width: 900px)": {
            display: "block",
            overflowWrap: "break-word",
        },
    },
    addIcon: {
        fontSize: "1.35rem",
        "@media (max-width: 900px)": {
            fontSize: "1.05rem",
        },
    },
}));

const FloatingButton = ({ onClick }) => {
    const classes = useStyles();
    return (
        <div className={classes.floatingButton} onClick={onClick}>
            <div className={classes.iconContainer}>
                <AddIcon className={classes.addIcon} />
            </div>
            <div className={classes.textContainer}>
                <span className={classes.labelText}>Add Patient Report</span>
            </div>
        </div>
    );
};

export default FloatingButton;
